import React, { useState, useEffect } from "react";
import image from "../Landingpages/Images/h.png";
import scannerImg from "../Landingpages/Images/qr-code.png";
import wrapImage from "../Landingpages/Images/food.avif"; // adjust path as per your folder structure
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const MainBanner = () => {
    const [showPopup, setShowPopup] = useState(false);

    const [showForgetPassword, setShowForgetPassword] = useState(false);
    const [isForgot, setIsForgot] = useState(false);

    const [loginObj, setLoginObj] = useState({
        // For Login
        identifier: "",
        password: "",

        // For Signup
        userName: "",
        emailId: "",
        mobileNumber: "",
        companyName: "",
        referralCodeUsed: ""
    });

    const [hidePassword, setHidePassword] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [whatsapp, setWhatsapp] = useState('');
    // Add these to your existing state
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [signupType, setSignupType] = useState("personal");

    const handleChange = (e) => {
        setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        // ✅ Use the same structure as your working Cloudnavbar
        const requestBody = {
            userName: loginObj.userName || loginObj.username, // Map accordingly
            emailId: loginObj.emailId || loginObj.email,
            password: loginObj.password,
            mobileNumber: loginObj.mobileNumber || loginObj.phoneNumber,
            referralCodeUsed: loginObj.referralCodeUsed || null,
            companyName: loginObj.companyName || null,
            role: "ROLE_USER",
            userType: "PERSONAL", // or get from state if you have user type selection
            termsAndConditions: true, // Add this if required
        };

        console.log("📌 Signup Request Body:", requestBody);

        // ✅ Use the same API endpoint as your working Cloudnavbar
        const apiUrl = "https://backend.maamaas.com/subscription/api/user/registration";

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            console.log("📌 Response Status:", response.status);

            const result = await response.json().catch(() => ({}));
            console.log("📌 Response Body:", result);

            if (response.ok) {
                alert("Signup successful!");
                setIsSignup(false);
                setIsForgot(false);
            } else {
                setError(result.message || "Signup failed");
            }
        } catch (error) {
            console.error("❌ Error during signup:", error);
            setError("Something went wrong. Please try again.");
        }

        setIsLoading(false);
    };
    const handleChanges = (e) => {
        const { name, value } = e.target;
        setLoginObj({ ...loginObj, [name]: value });
    };

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            // ✅ Create URL with query parameters
            const url = `https://backend.maamaas.com/subscription/api/auth/login/user?identifier=${encodeURIComponent(
                loginObj.identifier
            )}&password=${encodeURIComponent(loginObj.password)}`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    accept: "*/*",
                },
            });

            // ✅ Try to parse JSON safely
            const text = await response.text();
            let data;
            try {
                data = JSON.parse(text);
            } catch {
                console.error("❌ Server did not return JSON:", text);
                throw new Error("Invalid JSON response from server");
            }

            console.log("🔹 Login API Response:", data);

            if (response.ok && data.token) {
                // ✅ Store both tokens and user details
                localStorage.setItem("authToken", data.token);
                localStorage.setItem("refreshToken", data.refreshToken);
                localStorage.setItem("userId", data.userId);
                localStorage.setItem("userType", data.userType || "");
                localStorage.setItem("professionalUserId", data.professionalUserId);
                localStorage.setItem("role", data.role);
                localStorage.setItem("isLoggedIn", "true");

                alert("Login successful!");
                setIsLoggedIn(true);
                setShowLogin(false);
                navigate("/homepage");  // ← CHANGED TO REDIRECT TO /cloddata
            } else {
                setError(data.message || "Login failed. Please try again.");
            }
        } catch (error) {
            console.error("❌ Login error:", error);
            setError("Email or Password wrong. Please try again later.");
        } finally {
            setIsLoading(false);
        }


    };


    //forgot password

    const [loading, setLoading] = useState(false);

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const response = await fetch(
                "http://10.10.20.9:6300/Mamaswebsite-0.0.1-SNAPSHOT/forgot/password",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "*/*",
                    },
                    body: JSON.stringify({ identifier: email }),
                }
            );

            const text = await response.text(); // Because your response is not valid JSON
            if (!response.ok) {
                throw new Error(text || "Something went wrong.");
            }

            setMessage("Reset link sent successfully! your email address");
            setIsEmailSubmitted(true); // ✅ show only message after submission
        } catch (error) {
            setMessage(error.message || "Something went wrong. Try again later.");
        } finally {
            setLoading(false);
        }
    };

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const [showLogin, setShowLogin] = useState(false);
    const [isSignup, setIsSignup] = useState(false); // ← Add this line
    const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);

    const styles = {
        section: {
            padding: "20px",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "#2a0947",
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            padding: "15px 20px",
            borderRadius: "8px",
            marginBottom: "30px",
            flexWrap: "wrap",
        },
        logo: {
            fontSize: "30px",
            fontWeight: "bold",
            fontFamily: "roboto",
            color: "#ffe124",
        },
        signIn: {
            backgroundColor: "white",
            border: "2px solid white",
            color: "white",
            fontWeight: "bold",
            fontSize: "18px",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
            color: "rgb(42 9 71)4",
        },

        topText: {
            textAlign: "center",
            marginBottom: "40px",
        },

        topH2: {
            fontSize: "54px",
            marginBottom: "10px",
            fontWeight: "bold",
            color: "white",
        },
        topP: {
            fontSize: "54px",
            fontWeight: "bold",
            color: "white",
        },
        contentContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
            marginBottom: "40px",
            flexWrap: "wrap",
            // marginTop: "-98px",
        },
        textSection: {
            flex: 1,
            minWidth: "280px",
            marginTop: "-25px",
        },
        textH3: {
            fontSize: "40px",
            marginBottom: "10px",
            color: "white",
            fontWeight: "bold",
            textAlign: "left",
            marginLeft: "53px",
        },
        textP: {
            fontSize: "20px",
            color: "white",
            textAlign: "left",
            fontWeight: "200",
            fontWeight: "bold",
            fontFamily: "revert",
        },
        imageSection: {
            flex: 1,
            textAlign: "center",
        },
        image: {
            maxWidth: "100%",
            height: "auto",
            borderRadius: "10px",
        },
        counterContainer: {
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            gap: "20px",
            borderTop: "1px solid #ddd",
            paddingTop: "20px",
        },

        buttonContainer: {
            marginTop: "20px",
        },
        downloadBtn: {
            backgroundColor: "#ffe124",
            color: "rgb(42 9 71)4",
            padding: "12px 25px",
            fontSize: "16px",
            border: "none",
            fontSize: "20px",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "0.3s ease",
            fontWeight: "bold",
            zIndex: "10",
        },
        popupOverlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
        },
        popupInner: {
            background: "white",
            padding: "30px",
            borderRadius: "10px",
            textAlign: "center",
            position: "relative",
            maxWidth: "400px",
            animation: "slideUp 0.4s ease",
            zIndex: 1001,
            pointerEvents: "auto",
        },
        closeBtn: {
            position: "absolute",
            top: "10px",
            right: "15px",
            fontSize: "20px",
            background: "none",
            border: "none",
            cursor: "pointer",
        },
        scannerImg: {
            width: "200px",
            height: "auto",
            marginBottom: "15px",
        },
        imageSection: {
            marginTop: "40px",
            textAlign: "center",
        },
        image: {
            width: "100%",
            maxWidth: "600px",
            height: "385px",
            borderRadius: "10px",
            marginTop: "-64px",
        },

        // Responsive styles using media queries
        "@media screen and (max-width: 768px)": {
            header: {
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
            },
            topH2: {
                fontSize: "30px",
                color: "white",
            },
            topP: {
                fontSize: "14px",
                color: "white",
            },
            textP: {
                fontSize: "14px",
                color: "white",
            },
            counterH1: {
                fontSize: "24px",
            },
            contentContainer: {
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
            },
            textSection: {
                width: "100%",
            },
            imageSection: {
                width: "100%",
            },
        },
    };

    return (
        <div style={styles.section}>
            {/* Header */}
            <div className="imagenavbar" style={styles.header}>
                <div className="nav-maamaas" style={styles.logo}>
                    MAAMAA’S
                </div>

                <div
                    className="nav-links d-flex align-items-center gap-4"
                    style={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                    <button
                        className="signinnmaamaas"
                        style={{
                            backgroundColor: "rgb(255 225 36)",
                            color: "black",
                            fontSize: "20px",
                            fontFamily: "Lato, sans-serif",
                            fontWeight: "bold",
                            borderRadius: "16px",
                            width: "90px",
                            height: "40px",
                            border: "none",
                            cursor: "pointer",
                        }}
                        onClick={() => setShowLogin(true)}
                    >
                        Signin
                    </button>
                </div>

                <div
                    style={{
                        position: "fixed",
                        top: 20,
                        right: showLogin ? "0" : "-100%",
                        width: "100%",
                        maxWidth: "400px",
                        height: "76vh",
                        backgroundColor: "white",
                        borderRadius: "20px",
                        padding: "40px 30px",
                        boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.1)",
                        transition: "right 0.5s ease-in-out",
                        zIndex: 999,
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        overflowY: "auto",
                    }}
                >
                    {/* Close Button */}
                    <button
                        style={{
                            position: "absolute",
                            top: "15px",
                            right: "20px",
                            fontSize: "28px",
                            background: "none",
                            border: "none",
                            color: "#333",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            setShowLogin(false);
                            setIsForgot(false);
                            setIsSignup(false);
                        }}
                    >
                        &times;
                    </button>

                    <p
                        style={{
                            marginBottom: 0,
                            fontFamily: "revert",
                            fontSize: "22px",
                            color: "#2a0947",
                            fontWeight: "bold",
                        }}
                    >
                        WELCOME TO MAAMAA'S
                    </p>

                    {/* Login Form */}
                    {!isSignup && !isForgot && (
                        <>
                            <form
                                onSubmit={handleLogin}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                <input
                                    type="text"
                                    name="identifier"
                                    placeholder="Enter username"
                                    value={loginObj.identifier}
                                    onChange={handleChange}
                                    style={{
                                        padding: "10px 40px 10px 10px", // space on right for the icon
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                />

                                <div
                                    style={{
                                        position: "relative",
                                        marginBottom: "20px",
                                        width: "100%",
                                    }}
                                >
                                    <input
                                        type={hidePassword ? "password" : "text"}
                                        name="password"
                                        placeholder="Enter Password"
                                        value={loginObj.password}
                                        onChange={handleChange}
                                        style={{
                                            padding: "10px 40px 10px 10px", // space on right for the icon
                                            fontSize: "16px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                    <span
                                        onClick={() => setHidePassword((prev) => !prev)}
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#555",
                                        }}
                                    >
                                        {hidePassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>

                                <div style={{ textAlign: "right" }}>
                                    <span
                                        onClick={() => setIsForgot(true)}
                                        style={{
                                            color: "#007bff",
                                            fontSize: "14px",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Forget Password?
                                    </span>
                                </div>
                                {error && (
                                    <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
                                )}
                                <button
                                    type="submit"
                                    style={{
                                        backgroundColor: "rgb(42 9 71)",
                                        color: "white",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                    }}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Logging in..." : "LOGIN"}
                                </button>
                            </form>
                        </>
                    )}

                    {/* Forgot Password Form */}

                    {/* Show form only if NOT submitted */}
                    {isForgot && !isEmailSubmitted && (
                        <div>
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        style={{
                                            padding: "10px",
                                            fontSize: "16px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            marginBottom: "10px",
                                            width: "100%",
                                        }}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    style={{
                                        backgroundColor: "rgb(42 9 71)",
                                        color: "white",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        width: "100%",
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? "Sending..." : "Submit"}
                                </button>
                            </form>
                        </div>
                    )}

                    {/* Show success message only after submit */}
                    {isForgot && isEmailSubmitted && (
                        <div style={{ textAlign: "center", marginTop: "30px" }}>
                            {/* <h3 style={{ color: "green" }}>✅ Check your email</h3> */}
                            <p>
                                {message ||
                                    "A reset password link has been sent to your email address."}
                            </p>
                        </div>
                    )}

                    {/* Signup Form */}
                    {isSignup && (
                        <>
                            <form
                                onSubmit={handleSignup}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                <input
                                    type="text"
                                    name="userName"
                                    placeholder="Name"
                                    value={loginObj.userName}
                                    onChange={handleChange}
                                    style={{
                                        padding: "10px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                    }}
                                />
                                <input
                                    type="email"
                                    name="emailId"
                                    placeholder="Email"
                                    value={loginObj.emailId}
                                    onChange={handleChange}
                                    style={{
                                        padding: "10px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                    }}
                                />
                                <input
                                    type="text"
                                    name="mobileNumber"
                                    placeholder="Phone Number"
                                    value={loginObj.mobileNumber}
                                    onChange={handleChange}
                                    style={{
                                        padding: "10px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                    }}
                                />
                                <div
                                    style={{
                                        position: "relative",
                                        marginBottom: "20px",
                                        width: "100%",
                                    }}
                                >
                                    <input
                                        type={hidePassword ? "password" : "text"}
                                        name="password"
                                        placeholder="Create Password"
                                        value={loginObj.password}
                                        onChange={handleChange}
                                        style={{
                                            padding: "10px 40px 10px 10px", // space on right for the icon
                                            fontSize: "16px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                    <span
                                        onClick={() => setHidePassword((prev) => !prev)}
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#555",
                                        }}
                                    >
                                        {hidePassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>

                                <div
                                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                >
                                    <input type="checkbox" />
                                    <a
                                        href="/gaming"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            fontSize: "14px",
                                            color: "#007bff",
                                            textDecoration: "none",
                                        }}
                                    >
                                        Terms & Conditions
                                    </a>
                                </div>

                                <button
                                    type="submit"
                                    style={{
                                        backgroundColor: "rgb(42 9 71)",
                                        color: "white",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                    }}
                                >
                                    {isLoading ? "Signing up..." : "SIGN UP"}
                                </button>

                                {error && (
                                    <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
                                )}
                            </form>
                        </>
                    )}

                    {/* Switch Between Login & Signup */}
                    {!isForgot && (
                        <div style={{ textAlign: "center" }}>
                            <p style={{ fontSize: "14px" }}>
                                {isSignup
                                    ? "Already have an account?"
                                    : "Don't have an account?"}{" "}
                                <span
                                    onClick={() => {
                                        setIsSignup(!isSignup);
                                        setIsForgot(false);
                                    }}
                                    style={{
                                        color: "rgb(42 9 71)",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    {isSignup ? "Login here" : "Sign up"}
                                </span>
                            </p>
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "20px",
                                    justifyContent: "center",
                                }}
                            >
                                <img
                                    src={wrapImage}
                                    alt="wrap"
                                    style={{ width: "100px", display: "block" }}
                                />
                                <img
                                    src={wrapImage}
                                    alt="wrap"
                                    style={{ width: "100px", display: "block" }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div style={styles.topText}>
                <p className="mainbnner-maamaas" style={styles.topH2}>
                    {" "}
                    India’s First Zero Commission Platform
                </p>
                <p className="mainbnner-maamaas" style={styles.topP}>
                    One Platform. Infinite Possibilities
                </p>
                <div style={styles.buttonContainer}>
                    <button style={styles.downloadBtn} onClick={togglePopup}>
                        Download App
                    </button>
                </div>

                {showPopup && (
                    <div className="read-popup-inner" style={styles.popupOverlay}>
                        <div className="read-popup-inner" style={styles.popupInner}>
                            <button style={styles.closeBtn} onClick={togglePopup}>
                                ×
                            </button>
                            <img
                                src={scannerImg}
                                alt="QR Code Scanner"
                                style={styles.scannerImg}
                            />
                            <p>Scan the QR code to download the Maamaas App!</p>
                        </div>
                    </div>
                )}
            </div>

            {/* Content */}
            <div className="welcome-maamaastext" style={styles.contentContainer}>
                <div className="" style={styles.textSection}>
                    <p className="maamaas-welcome" style={styles.textH3}>
                        Welcome to Maamaas
                    </p>
                    <p
                        style={{
                            textAlign: "justify",
                            fontSize: "18px",
                            lineHeight: "1.8",
                            fontFamily: "Roboto, sans-serif",
                            fontWeight: "400",
                            margin: "0 auto",
                            width: "90%",
                            color: "white",
                        }}
                    >
                        India’s first zero-commission, all-in-one lifestyle platform
                        designed to simplify your daily life while saving your time and
                        money. In a world where everything comes with hidden charges, long
                        waits, and overpriced services, Maamaas flips the script. We’re here
                        to make everyday tasks easier, faster, and more affordable – all
                        while supporting the local businesses you know and love. Whether
                        you’re craving a home-style meal, booking a cab, grabbing groceries,
                        or scheduling services – Maamaas has your back.
                    </p>
                </div>
                <div style={styles.imageSection}>
                    <img src={image} alt="Learning" style={styles.image} />
                </div>
            </div>

            {/* Counter Section */}
        </div>
    );
};

export default MainBanner;
